import { render, staticRenderFns } from "./ReviewAttributes.vue?vue&type=template&id=7b62845a&scoped=true&"
import script from "./ReviewAttributes.vue?vue&type=script&lang=js&"
export * from "./ReviewAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b62845a",
  null
  
)

export default component.exports